import { useUsuarioLogado } from "@/contexts/autorizacao/usuario";
import { useMenu } from "@/shared/menu/useMenu";
import { OrderedListOutlined } from "@ant-design/icons";
import { Card, Col, Row } from "antd";
import { Link } from "react-router";

const cards = [
  {
    key: "requisicao",
    label: "Análises Laboratoriais - Requisições",
    to: "/analises-laboratoriais/requisicoes/lista",
    icon: <OrderedListOutlined />,
  },
  {
    key: "certificado",
    label: "Análises Laboratoriais - Certificados",
    to: "/analises-laboratoriais/certificados/lista",
    icon: <OrderedListOutlined />,
  },
  {
    key: "termo-notificacao-cadastro",
    label: "Termos de Notificação - Cadastramento",
    to: "/termos-notificacao/lista",
    icon: <OrderedListOutlined />,
  },
  {
    key: "termo-notificacao-plano-acao",
    label: "Termos de Notificação - Plano de Ação",
    to: "/termos-notificacao/plano-acao",
    icon: <OrderedListOutlined />,
  },
  {
    key: "ram-cadastro",
    label: "RAM - Cadastramento",
    to: "/RAM/lista",
    icon: <OrderedListOutlined />,
  },
  {
    key: "ram-plano-acao",
    label: "RAM - Plano de Ação",
    to: "/RAM/plano-acao",
    icon: <OrderedListOutlined />,
  },
  {
    key: "perfil",
    label: "Gerenciamento de Perfis",
    to: "/perfis",
    icon: <OrderedListOutlined />,
  },
];

export function MenuCard() {
  const { atualizarMenuSelected } = useMenu();
  const { usuarioLogado } = useUsuarioLogado();

  return (
    <>
      <Row
        gutter={[24, 24]}
        justify="center"
        style={{ marginTop: 40, marginBottom: 40 }}
      >
        {cards.map((card) => {
          if (card.key === "perfil" && usuarioLogado.perfil.id !== 1) {
            return null;
          }

          return (
            <Col key={card.to} xs={24} sm={12} md={6} lg={3}>
              <Link
                to={card.to}
                style={{ textDecoration: "none" }}
                onClick={() => {
                  atualizarMenuSelected([card.key]);
                }}
              >
                <Card
                  hoverable
                  style={{
                    width: "100%",
                    minHeight: 40,
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: 500,
                    textAlign: "center",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  {card.icon} {card.label}
                </Card>
              </Link>
            </Col>
          );
        })}
      </Row>
    </>
  );
}
